import { Box, makeStyles } from '@material-ui/core';
import React from 'react'
import { FileUploader } from 'react-drag-drop-files'
import { withSnackbar } from '../../../../utils/SnackbarHOC'
import { FileMetaData } from '../../../Candidat/CandidatForm/Controls/InputFile/InputFile.styles';
import { PreviewContainer } from '../../../Candidat/VisualiserCandidat/Controls/previewfiles.styles';

const fileTypes = ["XLSX"];

const useStyles = makeStyles((theme) => ({
    fileUploader: {
        maxWidth: 'initial !important'
    },
    asside: {
        marginTop: 'initial !important'
    },
    FileMetaData: {
        justifyContent: "space-between"
    }
}))

const Step2 = ({ importData, setImportData, snackbarShowMessage }) => {
    const classes = useStyles();
    
    const handleChange = (event) => {
        setImportData((prevState) => ({
            ...prevState,
            [event.target.name]: event.target.value
        }))
    }

    const handleContactsFileChange = (file) => {
        handleChange({
            target: {
                name: 'contactsFile',
                value: file
            }
        })
    }

    return (
        <>
            <FileUploader
                handleChange={handleContactsFileChange}
                name="file"
                types={fileTypes}
                label={"IMPORTER LE FICHIER DES CONTACTS"}
                classes={classes.fileUploader}
            />
            {
                importData?.contactsFile
                ? <PreviewContainer>
                    <Box>
                        <FileMetaData className={classes.FileMetaData}>
                            <span>{importData?.contactsFile.name}</span>
                        </FileMetaData>
                    </Box>
                </PreviewContainer>
                : ""
            }

        </>
    )
}

export default withSnackbar(Step2)